import React from 'react';
import { bool, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
const BaseSelectedIndicator = _ref => {
  let {
    className,
    element,
    isSelected
  } = _ref;
  const StyledElement = styled(element)(_ref2 => {
    var _components$SovosNavi, _components$SovosNavi2;
    let {
      theme: {
        components,
        palette,
        spacing
      }
    } = _ref2;
    return {
      borderRadius: spacing(1),
      height: spacing(3),
      '&.sovosNavigationLinks__linkSelectedIndicator--selected': {
        backgroundColor: (_components$SovosNavi = components === null || components === void 0 || (_components$SovosNavi2 = components.SovosNavigation) === null || _components$SovosNavi2 === void 0 ? void 0 : _components$SovosNavi2.styleOverrides.highlights) !== null && _components$SovosNavi !== void 0 ? _components$SovosNavi : palette.primary.main
      }
    };
  });
  return /*#__PURE__*/React.createElement(StyledElement, {
    className: clsx(className, 'sovosNavigationLinks__linkSelectedIndicator', {
      'sovosNavigationLinks__linkSelectedIndicator--selected': isSelected
    })
  });
};
BaseSelectedIndicator.propTypes = {
  className: string,
  element: string.isRequired,
  isSelected: bool.isRequired
};
export default BaseSelectedIndicator;